import React, { useEffect } from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import sixDotIcon from "../../images/6doticon.svg";
import warningBlue from "../../images/warning-red-icon.svg";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import AssignsymbolPopup from "../AssignSymbols/AssignsymbolPopup";
import CustomModal from "../CustomModal";
import AccordionClaim from "../AssignSymbols/AccordionClaim";
import { getAllScripts, updatSlideData } from "../../services/apis";
import CircularProgressBar from "../../utils/CircularProgressBar";
import { styled } from "@mui/material/styles";

const AssociatedCard = ({
  claim,
  reusableText,
  component,
  sendAtomDetails2Canvas,
  index,
  setExpandModule,
  expandModule,
  modulesArray,
  customDrag,
  editor,
  moduleClaimsData,
  modulesList,
}) => {
  const [expand, setExpand] = useState(false);
  const [testw, setTest] = useState(true);
  const [expandRelatedClaim, setExpandRelatedClaim] = useState(false);
  const [assignedSymbols, setAssignedSymbols] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);

  const { pageId } = useParams();

  //editor.on("load", )

  //  editor.on('canvas:drop', (cmp,block)=>{

  //  // debugger;
  //   setTest(true)
  //     // window.localStorage.setItem("eledrop", true);
  //   })
  // const test2 = () =>{
  //   //debugger
  //   return true
  // }
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }));

  editor?.on("component:add", function (elem) {
    // console.log(claimsOnEditorAsset, "claimsOnEditorAsset");
    setClaimsOnEditorAsset(!claimsOnEditorAsset);
    // return if its not parent claim
    if (!elem.getAttributes()["parent-claim"]) return;

    //if it is parent claim
    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps) {
        const claimParentOnEditor = allComps?.find(
          `[parent-claim=${claim.claimName}]`
        );
        let symbolElements = "";
        for (var i = 0; i < claimParentOnEditor.length; i++) {
          symbolElements = claimParentOnEditor[i]?.find("sup");
        }
        console.log("=========", symbolElements);

        if (symbolElements.length > 0) {

            

          symbolElements.forEach((symbolElement) => {
            if (elem.getAttributes()["parent-claim"] === claim.claimName)
              symbolElement.setStyle({ display: "none" });
            console.log(symbolElement);
          });
        }
      }
    } catch (err) {
      console.error("Error in wrapper.find:", err);
      return false;
    }
  }); // added to re-render the whole lfs on adding/removing text from editor

  editor?.on("component:remove:before", function (elem) {
    //console.log(elem, "claimsOnEditorAsset");
    setClaimsOnEditorAsset(!claimsOnEditorAsset);
    if (!elem.getAttributes()["related-claim"]) return;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    const claimParentOnEditor = allComps?.find(
      `[parent-claim=${claim.claimName}]`
    );
    let symbolElements = "";
    for (var i = 0; i < claimParentOnEditor.length; i++) {
      symbolElements = claimParentOnEditor[i]?.find("sup");
    }
    console.log("=========", symbolElements);

    if (symbolElements.length > 0) {
      symbolElements.forEach((symbolElement) => {
        if (
          elem.getAttributes()["related-claim"] ===
          symbolElement.getAttributes()["claim-id"]
        )
          symbolElement.setStyle({ display: "none" });
        console.log(symbolElement);
      });
    }
  });

  editor.on("component:remove", (component) => {
     setClaimsOnEditorAsset(!claimsOnEditorAsset);
    if (!component.getAttributes()["parent-claim"]) return;

    const parent = component.parent();
    if (!parent || parent.is("wrapper")) return;

    //parent.remove();
    setExpandRelatedClaim(!expandRelatedClaim);
  });

  const [claimsOnEditorAsset, setClaimsOnEditorAsset] = useState(false);
  const isDraggable = (claimMatchText) => {
    const decodedString = new DOMParser().parseFromString(
      editor?.getHtml(),
      "text/html"
    ).documentElement.textContent;
    return decodedString
      .replace(/\s+/g, "")
      .includes(claimMatchText?.replace(/\s+/g, ""));
  };

  const parentClaimAdded = (claimId) => {
    if (!editor) return false;
    const allComps = editor?.getWrapper();
    if (!allComps || typeof allComps.find !== "function") {
      return false;
    }
    try {
      if (allComps && claimId) {
        const claimParentOnEditor = allComps?.find(`[parent-claim=${claimId}]`);
        return claimParentOnEditor?.length > 0 ? true : false;
      }
    } catch (err) {
      console.error("Error in wrapper.find:", err);
      return false;
    }
  };
  const grayout = (claimMatchText) => {
    const decodedString = new DOMParser().parseFromString(
      editor?.getHtml(),
      "text/html"
    ).documentElement.textContent;
    return decodedString
      .replace(/\s+/g, "")
      .includes(claimMatchText?.replace(/\s+/g, ""));
  };

  const getAssignedSymbolsOnLoad = () => {
    setPreviewLoading(true);
    getAllScripts(pageId, (response, err, errorCode) => {
      if (err) {
        setPreviewLoading(false);
        // setIsloading(false);
      } else {
        // setIsloading(false);
        const selectedRelatedClaims = response?.data?.relatedClaimsData;
        const IdsModule = new Set(modulesList.map((item) => item.module_name));
        const filterClaims = selectedRelatedClaims.filter((item) =>
          IdsModule.has(item.moduleId)
        );
        const payLoad = {
          relatedClaimsData: filterClaims,
        };

        updatSlideData(pageId, payLoad, (response, err, errorCode) => {
          if (err) {
            // setIsloading(false);
          } else {
            // setIsloading(false);

            setAssignedSymbols(filterClaims);
          }
        });
        setPreviewLoading(false);
      }
    });
  };

  const dragMatch = (e, from) => {
    if (from === "footnotes") {
      e.dataTransfer.setData("text", e.target.innerText);
    } else if (from === "ref") {
      const el = e.currentTarget;
      const clone = el.cloneNode(true);

      clone.querySelector("span")?.remove();

      e.dataTransfer.setData("text/plain", clone.textContent.trim());
    } else {
      const el = e.target.innerHTML;
      e.dataTransfer.setData("text/html", e.target.lastChild.innerHTML);
    }
    e.dataTransfer.setDragImage(e.nativeEvent.srcElement, 0, 0);
  };

  return (
    <>
      {previewLoading && (
        <CircularProgressBar
          isloading={previewLoading}
          setIsloading={setPreviewLoading}
        />
      )}
      <div className="associated-modules" style={{ cursor: "pointer" }}>
        <div
          style={{ display: "flex", alignItems: "center" }}
          onClick={() => {
            const expandModuleArr = [...expandModule];
            expandModuleArr[index] = !expand;
            setExpandModule(expandModuleArr);
            setExpand(!expand);
            getAssignedSymbolsOnLoad();
          }}
        >
          <div
            className="expand-module"
            style={{
              backgroundColor: expand ? "#F0F5F8" : "",
              color: expand ? "#203662" : "",
              fontSize: expand ? "30px" : "20px",
              fontWeight: expand ? "100" : "",
            }}
            onClick={() => {
              setExpand(!expand);
              setExpandRelatedClaim(false);
            }}
          >
            {" "}
            {expand ? (
              <p className="minusIcon22">-</p>
            ) : (
              <p className="plusIcon22">+</p>
            )}{" "}
          </div>
          {claim && (
            <div className="boldText" style={{ marginLeft: "4px" }}>
              {claim.claimName}
            </div>
          )}
          {reusableText && (
            <div className="boldText" style={{ marginLeft: "4px" }}>
              {reusableText.reusableTextName}
            </div>
          )}
          {component && (
            <div className="boldText" style={{ marginLeft: "4px" }}>
              {component.componentDocNumber}
            </div>
          )}
          {claim && (
            <div
              className="parentModulebox"
              style={{
                backgroundColor: claim.mustUse === true ? "#E32B35" : "#378A05",
                marginLeft: "10px",
              }}
            ></div>
          )}
          {/* <div onClick={()=>setOpenAssignPopup(true)}>Assign Symbol</div>      */}
          {reusableText && (
            <div
              className="parentModulebox"
              style={{
                backgroundColor:
                  reusableText.mustUse === true ? "#E32B35" : "#378A05",
                marginLeft: "10px",
              }}
            ></div>
          )}
          {component && (
            <div
              className="parentModulebox"
              style={{
                backgroundColor:
                  component.mustUse === true ? "#E32B35" : "#378A05",
                marginLeft: "10px",
              }}
            ></div>
          )}
          {/* <img src={warningBlue} style={{ marginLeft: "10px" }} /> */}
        </div>
        {!expand && index !== modulesArray.length - 1 && (
          <div className="horizonatlLine"></div>
        )}
      </div>
      {expand && (
        <div classname="text-container pb-2">
          {claim && (
            <>
              {" "}
              <div className="matchText">Match Text </div>
              <div
                className={` d-flex draggableText  ${
                  parentClaimAdded(claim.claimName) ? "grayOut" : ""
                }`}
                draggable={!parentClaimAdded(claim.claimName)}
                onDragStart={(e) => dragMatch(e)}
                onDragEnd={(e) => {
                  setClaimsOnEditorAsset(!claimsOnEditorAsset);
                }}
              >
                <img src={sixDotIcon} alt="" className="img-fluid sixdotIcon" />
                <div className="textvariant">
                  {claim.matchText && (
                    <div
                      module-claim={moduleClaimsData?.moduleDamName}
                      parent-claim={claim.claimName}
                      className="parent-claim"
                    >
                      {claim.matchText}
                      {assignedSymbols
                        ?.filter(
                          (sym) =>
                            sym.claimId == claim.claimName &&
                            sym.moduleId == moduleClaimsData.moduleDamName
                        )
                        .map((data) => (
                          <sup
                            className="hide-Lhs-sup"
                            claim-id={data.relatedClaimId}
                          >
                            {data.symbol}
                          </sup>
                        ))}
                    </div>
                  )}
                </div>
              </div>
              <>
                {claim.matchTextVariants?.map((item, index) => {
                  return (
                    <>
                      <div className="matchText">{`Match Text Variant ${
                        index + 1
                      }`}</div>
                      <div
                        className={`d-flex draggableText" ${
                          parentClaimAdded(claim.claimName) ? "grayOut" : ""
                        }`}
                        draggable={!parentClaimAdded(claim.claimName)}
                        onDragStart={(e) => dragMatch(e)}
                        onDragEnd={(e) => {
                          setClaimsOnEditorAsset(!claimsOnEditorAsset);
                        }}
                      >
                        <img
                          src={sixDotIcon}
                          alt=""
                          className="img-fluid sixdotIcon"
                        />
                        <div className="textvariant">
                          {item.matchText && (
                            <div
                              module-claim={moduleClaimsData?.moduleDamName}
                              parent-claim={claim.claimName}
                              className="parent-claim"
                            >
                              {item.matchText}
                              {assignedSymbols
                                ?.filter(
                                  (sym) =>
                                    sym.claimId == claim.claimName &&
                                    sym.moduleId ==
                                      moduleClaimsData.moduleDamName
                                )
                                .map((data) => (
                                  <sup
                                    className="hide-Lhs-sup"
                                    claim-id={data.relatedClaimId}
                                  >
                                    {data.symbol}
                                  </sup>
                                ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </>
                  );
                })}
              </>
              {claim.footnotes?.length > 0 && (
                <div className="matchText1 ">Footnotes </div>
              )}
              <div
                className={`textvariant1 draggableText  ${
                  grayout(claim.footnotes) ? "grayOut" : ""
                }`}
                draggable={!isDraggable(claim.footnotes)}
                onDragStart={(e) => customDrag(e)}
                onDragEnd={(e) => {
                  setClaimsOnEditorAsset(!claimsOnEditorAsset);
                }}
              >
                {claim.footnotes}
              </div>
              {claim.references?.length > 0 && (
                <div className="matchText1">References</div>
              )}
              {claim.references?.map((item, index) => {
                return (
                  <>
                    <div
                      className={`textvariant1 draggableText  ${
                        grayout(item.documentName) ? "grayOut" : ""
                      }`}
                      draggable={!isDraggable(item.documentName)}
                      onDragStart={(e) => dragMatch(e, "ref")}
                      onDragEnd={(e) => {
                        setClaimsOnEditorAsset(!claimsOnEditorAsset);
                      }}
                    >
                      {" "}
                      <span>{index + 1}.{" "}</span>
                      {`${item.documentName}`}
                    </div>
                  </>
                );
              })}
              {claim.relatedClaims.length > 0 && ( //needs to work
                <div
                  style={{
                    display: "flex",
                    cursor: "pointer",
                    // pointerEvents: `${parentClaimAdded(claim.claimName) ? 'auto' : 'none'}`,
                    userSelect: "none",
                  }}
                  onClick={() => {
                    setExpandRelatedClaim(!expandRelatedClaim);
                    !expandRelatedClaim && getAssignedSymbolsOnLoad();
                  }}
                >
                  {
                    <div
                      className="expand-module"
                      style={{
                        backgroundColor: expandRelatedClaim ? "#F0F5F8" : "",
                        color: expandRelatedClaim ? "#203662" : "",
                        fontSize: expandRelatedClaim ? "24px" : "18px",
                        fontWeight: expandRelatedClaim ? "100" : "",
                        cursor: "pointer",
                        marginRight: "6px",
                      }}
                    >
                      {" "}
                      {expandRelatedClaim ? (
                        <p className="minusIcon22">-</p>
                      ) : (
                        <p className="plusIcon22">+</p>
                      )}{" "}
                    </div>
                  }
                  <div className="related-claim-block">
                    {`Related Claims`}
                    <span
                      style={{
                        color: "#888",
                        fontSize: "10px",
                        fontWeight: "400",
                      }}
                    >
                      {" "}
                      {`(${claim.relatedClaims.length} items)`}{" "}
                    </span>
                  </div>
                  <div
                    className="info-icon-div"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {
                      <LightTooltip
                        className="mlrToolTip"
                        title="To use Related Claims, first drag and drop a Claim into the editor, then assign a claim symbol to the Related Claims"
                        arrow
                      >
                        <img
                          src={warningBlue}
                          style={{
                            marginLeft: "10px",
                            pointerEvents: `${
                              parentClaimAdded(claim.claimName)
                                ? "auto"
                                : "auto"
                            }`,
                          }}
                        />
                      </LightTooltip>
                    }
                  </div>
                </div>
              )}
              {assignedSymbols !== null && expandRelatedClaim && (
                <AccordionClaim
                  relatedClaims={claim.relatedClaims}
                  claim={claim}
                  customDrag={customDrag}
                  setClaimsOnEditorAsset={setClaimsOnEditorAsset}
                  editor={editor}
                  claimsOnEditorAsset={claimsOnEditorAsset}
                  moduleClaimsData={moduleClaimsData}
                  assignedSymbols={assignedSymbols}
                  setAssignedSymbols={setAssignedSymbols}
                  setPreviewLoading={setPreviewLoading}
                  previewLoading={previewLoading}
                />
              )}
              {index !== modulesArray.length - 1 && (
                <div className="horizonatlLine"></div>
              )}
            </>
          )}
          {reusableText && (
            <>
              {" "}
              <div className="matchText">Match Text</div>
              <div
                className={` d-flex draggableText  ${
                  isDraggable(reusableText.matchText) ? "grayOut" : ""
                }`}
                draggable={!isDraggable(reusableText.matchText)}
                onDragStart={(e) => customDrag(e)}
                onDragEnd={(e) => {
                  setClaimsOnEditorAsset(!claimsOnEditorAsset);
                }}
              >
                <img src={sixDotIcon} alt="" className="img-fluid sixdotIcon" />
                <div className="textvariant">{reusableText.matchText}</div>
              </div>
              {index !== modulesArray.length - 1 && (
                <div className="horizonatlLine"></div>
              )}
            </>
          )}

          {component && (
            <>
              <div className="matchText">Image</div>
              <div
                className="d-flex draggableText"
                //   draggable={test()}
                onDragStart={(e) => customDrag(e)}
                // onDragEnd={test2()&&testw}
              >
                <img src={sixDotIcon} alt="" className="img-fluid sixdotIcon" />
                <div className="textvariant drag-image">
                  <img
                    src={component?.componentUrl}
                    alt=""
                    className="img-fluid sixdotIcon"
                    draggable="true"
                    onDragStart={(event) => {
                      // const data = JSON.stringify({
                      //   url: component?.componentUrl,
                      //   name: component?.name || 'Dropped image'
                      // });
                      const data = JSON.stringify(component?.componentUrl);
                      event.dataTransfer.setData("application/json", data);
                      event.dataTransfer.effectAllowed = "copy";
                    }}
                    // style={{cursor: 'all-scroll'}}
                  />
                </div>
              </div>
              {component?.title && (
                <>
                  <div className="matchText">Title</div>
                  <div
                    className={` d-flex draggableText  ${
                      isDraggable(component.title) ? "grayOut" : ""
                    }`}
                    draggable={!isDraggable(component.title)}
                    onDragStart={(e) => customDrag(e)}
                    onDragEnd={(e) => {
                      setClaimsOnEditorAsset(!claimsOnEditorAsset);
                    }}
                  >
                    <img
                      src={sixDotIcon}
                      alt=""
                      className="img-fluid sixdotIcon"
                    />
                    <div className="textvariant">{component.title}</div>
                  </div>
                </>
              )}

              {index !== modulesArray.length - 1 && (
                <div className="horizonatlLine"></div>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};
export default AssociatedCard;
